module.exports = __webpack_public_path__ + "img/1086315045.b461da33.jpg";